import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track11ERed = ({ state, workState, onLabelClick }) => (
	<g id="Track11ERed" transform="translate(2145.000000, 608.000000)" className="track">
		<g id="line"
			 transform="translate(0.486377, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="0.795351588" y1="0.333732633" x2="13.1058022" y2="26.4289035"/>
			<TrackArrow transform="translate(12.288144, 24.070840) rotate(-112.000000) translate(-12.288144, -24.070840) "
									points="16.2881442 32.0708396 8.28814423 24.0708396 16.2881442 16.0708396"/>
			<line x1="17.0060998" y1="36.8925607" x2="68" y2="173"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track11ERed')}
			coords="9.000000, 47.167969"
			text="11E"
			textCoordsX="8.83056641"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track11ERed.propTypes = trackPropTypes;

export default Track11ERed;
